import { Outlet } from "react-router-dom";
import { TabBar } from "./TabBar";
import { SideRail } from "./SideRail";
import { OfflineBanner } from "./OfflineBanner";
import { useViewMode } from "@/hooks/useViewMode";
import { useUnreadCount } from "@/hooks/useUnread";
import { useActivity } from "@/hooks/useActivity";
import { AssistantProvider } from "@/assistant/AssistantProvider";
import { AssistantSurfaces } from "@/components/assistant/AssistantSurfaces";

/** Signed-in layout: routed screen, the tab bar (phone) or side rail (desktop), the offline notice and the assistant. */
export function AppShell() {
  const { mode } = useViewMode();
  const unread = useUnreadCount();
  useActivity();
  return (
    <AssistantProvider>
      <div className="min-h-dvh bg-background">
        <OfflineBanner />
        <SideRail mode={mode} unread={unread} />
        {/* Phone: full width above the tab bar. 1024px and up: beside the rail. */}
        <div className="lg:pl-60">
          <Outlet context={{ mode }} />
        </div>
        <TabBar mode={mode} unread={unread} />
        <AssistantSurfaces />
      </div>
    </AssistantProvider>
  );
}
